<app-dynamic-form title="Employer" [input]="data!" (result)="doHandleResult($event)"></app-dynamic-form>
